

import React, { forwardRef, useEffect, useState } from "react";

const CustomCurrencyInput = forwardRef(
  (
    {
      maxDecimal = 0,
      currencyFormat,
      value = "",
      onChange,
      onKeyDown,
      disabled,
      className,
      onFocus,
      onKeyUp,
      maxDigit = 8,
      onBlur,
      style,
    },
    ref,
  ) => {
    const [formatValue, setFormatValue] = useState("");

    const formatCurrency = (inputValue) => {
      let raw = String(inputValue || "");
      let numericValue = raw.replace(/[^0-9.]/g, "");

      const parts = numericValue.split(".");
      if (parts.length > 2) {
        numericValue = `${parts[0]}.${parts.slice(1).join("")}`;
      }

      if (numericValue === "" || numericValue === ".") {
        return numericValue === "." ? "0." : "";
      }

      if (numericValue.startsWith(".")) {
        numericValue = "0" + numericValue;
      }

      let [integerPart, decimalPart] = numericValue.split(".");
      integerPart = integerPart.replace(/^0+(?=\d)/, "") || "0";
      integerPart = integerPart.replace(/,/g, "").slice(0, maxDigit);

      let formattedInteger = integerPart;

      if (currencyFormat === "US") {
        formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (currencyFormat === "INDIAN" && integerPart.length > 3) {
        const lastThree = integerPart.slice(-3);
        const otherNumbers = integerPart.slice(0, -3);
        formattedInteger =
          (otherNumbers
            ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + ","
            : "") + lastThree;
      }

      let formattedValue = formattedInteger;
      if (maxDecimal > 0) {
        if (decimalPart !== undefined) {
          formattedValue += "." + decimalPart.slice(0, maxDecimal);
        } else if (raw.endsWith(".") && maxDecimal > 0) {
          formattedValue += ".";
        }
      }

      return formattedValue;
    };

    const handleChange = (e) => {
      const rawValue = e.target.value;
      const formatted = formatCurrency(rawValue);
      setFormatValue(formatted);
      onChange(formatted.replace(/[^0-9.]/g, ""));
    };

    useEffect(() => {
      setFormatValue(formatCurrency(value));
    }, [value, maxDecimal]);

    return (
      <input
        // value={formatValue}
        // value={disabled && !formatValue ? formatCurrency("0") : formatValue}
        value={formatValue !== "" ? formatValue : "0"}
        ref={ref}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        disabled={disabled}
        className={className}
        onFocus={onFocus}
        onKeyUp={(e) => {
          if (onKeyUp) {
            onKeyUp(e); // Call the passed onKeyUp function
          }
        }}
        onBlur={onBlur}
        style={style}
      />
    );
  },
);

export default CustomCurrencyInput;
